document.addEventListener('DOMContentLoaded', () => {
  $(document).off('click', '.accordion-header').on('click', '.accordion-header', function(e) {
    e.preventDefault();
    e.stopPropagation();
    let toggleBtn = $(this)?.find('.accordion-toggle-btn');
    let accordionBody = $(this)?.siblings('.accordion-body');
    if (accordionBody.is(':hidden')) {
      toggleBtn?.attr('aria-expanded', 'true');
    } else {
      toggleBtn?.attr('aria-expanded', 'false');
    }
    accordionBody.slideToggle();
  });
  $(document).off('keydown', '.accordion-header').on('keydown', '.accordion-header', function(e) {
    if (e.key == 'Enter' || e.key == ' ') {
      e.preventDefault();
      e.stopPropagation();
      $(this).click();
    }
  });
});